module.exports = __webpack_public_path__ + "img/calendar-1.591db0b1.svg";